import request from '../../../core/wrappers/axios-wrapper';
import { ApiURL } from '../../../types/constants/apiUrls/api-urls';
import { RequestType } from '../../../types/enums/request-enums';

const SaveCategoryRestrictions = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.SaveCategoryRestrictions,
        method: RequestType.POST,
        data,
    });

const CategoryRestrictionCommand = { SaveCategoryRestrictions };

export default CategoryRestrictionCommand;
